
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pet/cats",
      function () {
        return require("private-next-pages/pet/cats.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pet/cats"])
      });
    }
  